import {Button, Card, Input, Pagination, Row, Table, Tabs, Tag, Icon, Spin, Collapse, Dropdown, Select, DatePicker, Checkbox} from 'antd';
import {ColumnProps} from 'antd/lib/table';
import React from 'react';
import {Order, OrderSubfield} from '../../../../interfaces';
import Detail from './components/Detail';

import ExportModal from './ExportModal';
import './style.css';
import moment from 'moment';

const TabPane = Tabs.TabPane;
const {Panel} = Collapse;

enum FilterType {
  FULLTEXT = 'fulltext',
  DATE_FROM = 'dateFrom',
  DATE_TO = 'dateTo',
  CLUBS = 'clubs',
}
interface Properties {
  orderData: Array<Order>;
  columns: Array<ColumnProps<Order>>;
  totalPages: number;
  refetch: (variables: any) => void;
  regionId: string;
  loading: boolean;
  clubs: Club[];
}

interface State {
  filter: Filter;
  activeKey: string;
  currentPage: number;
  isExportModalOpen: boolean;
  isDropdownOpen: boolean;
}

interface Filter {
  fulltext: string;
  dateFrom: string;
  dateTo: string;
  clubs: string[];
}

interface Club {
  id: string;
  name: string;
}

class ListOrders extends React.PureComponent<Properties, State> {
  state: State = {
    activeKey: '',
    filter: {
      fulltext: '',
      dateFrom: '',
      dateTo: '',
      clubs: [],
    },
    isDropdownOpen: false,
    currentPage: 1,
    isExportModalOpen: false,
  };
  filterDebounce: NodeJS.Timeout = null;

  componentDidMount() {
    window.addEventListener('click', this.clickedOnScreen);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.clickedOnScreen);
  }

  /** Refetches orders with current parameters */
  refetchData = () => {
    const {refetch, regionId} = this.props;
    const {filter, currentPage} = this.state;
    refetch({regionId, first: 10, after: (currentPage - 1) * 10, filter: JSON.stringify(filter)});
  };

  /** Refetch data after page changes */
  onPaginationChange = (pageNumber: number) => {
    this.setState({currentPage: pageNumber}, this.refetchData);
  };

  /** Add hashNumber to location and expands order details */
  onPanelChange = (expanded: boolean, {id}: {id: string}): void => {    
    this.setState({activeKey: expanded ? id : null});
  };

  /** Handling export CSV Modal */
  openExportModal = () => {
    this.setState({isExportModalOpen: true});
  };
  closeExportModal = () => {
    this.setState({isExportModalOpen: false});
  };

  /** Detect if order has inside words - that matches 'Test' */
  isOrderSuggestedToBeMarkedAsTesting = ({person:{surname, name, email}}: any) => {    
    return surname.toLowerCase().includes('test') || name.toLowerCase().includes('test') || email.toLowerCase().includes('test');
  };

  /** Add background for table row if order used for testing */
  getRowClassName = ({order}: Order) => {
    
    if (order.isTesting) {
      return 'bg-test';
    }
    if (order.isTesting !== false && this.isOrderSuggestedToBeMarkedAsTesting(order)) {
      return 'bg-test-suggest';
    }
    return '';
  };

  /***************************************************************************** Filter **********************************************************************************/

  /** Open/Close filter drop down */
  toggleDropDown = () => this.setState({isDropdownOpen: !this.state.isDropdownOpen});

  /** Closes dropdown when you click outside dropdown */
  clickedOnScreen = (e: any) => {
    const path = e.path || (e.composedPath && e.composedPath());
    if (path && Array.isArray(path)) {
      const classPath = path.map(item => item.className).filter(item => !!item);
      if (this.state.isDropdownOpen && classPath.length) {
        if (!classPath.filter(Boolean).some(item => (item.includes('dropdownTools') || item.includes('filter-dropdown') || item.includes('ant-calendar')))) {
          this.setState({isDropdownOpen: false});
        }
      }
    }
  };

  /** Apply new filter */
  setFilter = (key: FilterType, value: any) => this.setState({filter: {...this.state.filter, [key]: value}});

  /** Wrapper for {@link setFilter} function */
  setFullTextFilter = (e: React.ChangeEvent<HTMLInputElement>) => this.setFilter(FilterType.FULLTEXT, e.target.value);
  setDateFromFilter = (value: moment.Moment) => this.setFilter(FilterType.DATE_FROM, value && value.toString());
  setDateToFilter = (value: moment.Moment) => this.setFilter(FilterType.DATE_TO, value && value.toString());
  setClubsFilter = (value: string[]) => this.setFilter(FilterType.CLUBS, value);

  getFilter() {
    const {filter} = this.state;
    return (
      <div className="dropdownTools">
        <Collapse>
          <Panel key={'1'} header="Submission Date">
            <div style={{marginBottom: 5}}>
              <span style={{display: 'block'}}>From</span>
              <DatePicker
                placeholder="From"
                onChange={this.setDateFromFilter}
                value={filter.dateFrom && moment(filter.dateFrom)}
                format="DD/MM/YYYY HH:mm"
                style={{width: '100%'}}
                showTime={{format: 'HH:mm'}}
              />
            </div>
            <div>
              <span style={{display: 'block'}}>To</span>
              <DatePicker
                placeholder="To"
                onChange={this.setDateToFilter}
                value={filter.dateTo && moment(filter.dateTo)}
                format="DD/MM/YYYY HH:mm"
                style={{width: '100%'}}
                showTime={{format: 'HH:mm'}}
              />
            </div>
          </Panel>
        </Collapse>
      </div>
    );
  }

  renderToolbar() {
    const {loading, clubs} = this.props;
    const {isDropdownOpen, filter} = this.state;

    const antIcon = <Icon type="loading" spin />;

    return (
      <Card className={'filter-card'}>
        <div className={'export-button-wrapper'}>
          <Button size={'small'} type="primary" onClick={this.openExportModal}>
            Export CSV
          </Button>
        </div>
        <div className={'filter-wrapper'}>
          <div>
            <Input
              value={filter.fulltext}
              className={'filter-input'}
              onChange={this.setFullTextFilter}
              placeholder="Filter by email, name"
            />
            <Dropdown visible={isDropdownOpen} overlay={this.getFilter()} placement="bottomRight">
              <Button onClick={this.toggleDropDown} className={'filter-dropdown'}>
                Filter
                <Icon type={isDropdownOpen ? 'close' : 'bars'} />
              </Button>
            </Dropdown>
            {loading ? (
              <Spin className={'spinner'} indicator={antIcon} />
            ) : (
              <Button onClick={this.refetchData} className={'filter-button'} type="primary">
                Filter
              </Button>
            )}
            <div>
              <Select className={'filter-select'} mode="multiple" placeholder="Clubs" value={filter.clubs} onChange={this.setClubsFilter}>
                {clubs
                  .sort((a, b) => (a.name < b.name ? -1 : 1))
                  .map((club, i) => (
                    <Select.Option value={club.name} key={i.toString()}>
                      {club.name}
                    </Select.Option>
                  ))}
              </Select>
              <div style={{paddingTop: 5}}>
                <Button onClick={() => this.setClubsFilter(clubs.map(club => club.name))}>Add All Clubs</Button>
                <Button style={{marginLeft: 5}} onClick={() => this.setClubsFilter([])}>
                  Remove All Clubs
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Card>
    );
  }

  /***************************************************************************** Filter **********************************************************************************/

  renderExpandedRow = (order: Order, index: number) => (
    <Row gutter={24}>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Detail" key="1">
          <Detail orderData={order} />
        </TabPane>
      </Tabs>
    </Row>
  );

  render() {
    const {filter, isExportModalOpen, activeKey} = this.state;
    const {regionId, columns, totalPages,orderData} = this.props;
    
    return (
      <div>
        <ExportModal isOpen={isExportModalOpen} regionId={regionId} closeModal={this.closeExportModal} filter={JSON.stringify(filter)} />
        {this.renderToolbar()}
        <Card bodyStyle={{padding: 0}}>
          <Table
            columns={columns}
            pagination={totalPages !== 0 ? false : undefined}
            rowClassName={this.getRowClassName}
            expandedRowKeys={activeKey ? [activeKey] : []}
            onExpand={this.onPanelChange}
            expandedRowRender={this.renderExpandedRow}
            dataSource={orderData.map((o: Order) => ({...o,key:o.id}))}
            scroll={{x: 'fit-content'}}
          />
          {totalPages !== 0 && <Pagination className={'ext-pagination'} total={this.props.totalPages} onChange={this.onPaginationChange} />}
        </Card>
      </div>
    );
  }
}

export default ListOrders;



// WEBPACK FOOTER //
// ./src/pages/SubmissionCrmErrorsPage/components/ListOrders/components/ListOrders/ListOrders.tsx